import type { VFC } from 'react';
import { Layout, StyledHeader } from '@/components/layout';
import { Col, Row } from 'antd';
import { ContentContainer, FlexContainer } from './components/Containers';
import { Hero } from './components/Hero';
import { AuthRouter } from './containers/Router';
import { LanguageMenu } from '@/components/LanguageMenu';

export const AuthPage: VFC = () => (
  <Layout style={{ height: '100%' }}>
    <StyledHeader>
      <Row justify="end">
        <Col>
          <LanguageMenu />
        </Col>
      </Row>
    </StyledHeader>
    <Row style={{ height: '100%' }}>
      <FlexContainer>
        <ContentContainer>
          <AuthRouter />
        </ContentContainer>
      </FlexContainer>
      <Hero />
    </Row>
  </Layout>
);
